/** Keep in sync with bedbooking_react_native/.../webViewLocalTaxPdfExportConstants.ts */
export const BB_LOCAL_TAX_PDF_EXPORT = 'BB_LOCAL_TAX_PDF_EXPORT'
export const BB_LOCAL_TAX_PDF_EXPORT_SCOPE = 'LocalTaxReport'

export const LOCAL_TAX_PDF_EXPORT_VERSION = 1

/** Keep in sync with bedbooking_react_native/.../webViewReservationPdfExportConstants.ts */
export const BB_RESERVATION_PDF_EXPORT = 'BB_RESERVATION_PDF_EXPORT'
export const BB_RESERVATION_PDF_EXPORT_SCOPE = 'Clients'

export const RESERVATION_PDF_EXPORT_VERSION = 1
